import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { SearchBar, Input, Select, DatePicker } from 'hljd'
import { STATUS_MAP } from '../../constant'

const Item = SearchBar.Item
const Option = Select.Option

@inject('store')
@observer
export default class extends Component {
  render() {
    const { store } = this.props

    return (
      <SearchBar store={store}>
        <Item label="活动标题" name="name">
          <Input placeholder="请输入搜索内容" />
        </Item>

        <Item label="活动状态" name="status">
          <Select style={{ width: 120 }} placeholder="请选择">
            {Object.keys(STATUS_MAP).map(key => {
              return (
                <Option key={key} value={key}>
                  {STATUS_MAP[key]}
                </Option>
              )
            })}
          </Select>
        </Item>

        <Item label="活动周期" name="time">
          <DatePicker.RangePicker />
        </Item>
      </SearchBar>
    )
  }
}
